import { useTranslation as useI18nTranslation } from 'react-i18next';
export const useTranslation = useI18nTranslation;
export { default as i18n } from './config';
export type { Language } from './config';
